export default "__VITE_ASSET___Yq2YiSQ__"